import React, {Fragment} from "react";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {withRouter} from "react-router-dom";
import CardBatchService from "../services/card/stock/CardBatchService";
import ToastHelper from "../utils/ToastHelper";
import CardBatch from "../domain/card/batch/CardBatch";
import CardBatchView from "./CardBatchView";
import SFXLoadingComponent from "../components/SFXLoadingComponent";
import QueryStringUtils from "../utils/QueryStringUtils";
import LinkComponent from "../components/LinkComponent";
import SearchInputGroup from "../components/SearchInputGroup";
import CustomPaginatedDataTableComponent from "../components/CustomPaginatedDataTableComponent";
import "../scss/CardBatchSearch.css";

const VIEW_STATE_SEARCH = "search"
const VIEW_STATE_VIEW = "view";

class CardBatchSearch extends React.Component {
    constructor(props) {
        super(props);

        this.searchRef = null;
        this.tableRef = null;

        this.props.changeHeader("Card Batches");
        this.baseUrl = "/card-batch";

        let viewState = this.getDefaultViewState();

        this.state = {
            ...viewState,
            cardBatches: [],
            loading: true,
        };

        this.handleSubmit = this.handleSubmit.bind(this);

    }

    getDefaultViewState() {
        let viewId = QueryStringUtils.getQueryStringValue("id");
        if (viewId !== null) {
            return {
                viewMode: VIEW_STATE_VIEW,
                batchId: viewId
            };
        } else {
            return {
                viewMode: VIEW_STATE_SEARCH,
                batchId: 0,
            };
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        let headers = this.tableRef === null ? {} : this.tableRef.getHeaders();
        let values = this.searchRef === null ? {search: ""} : this.searchRef.getValues();

        CardBatchService.retrieveAssignedBatchesForUser(values.search, headers).then(response => {
            if (Array.isArray(response.body)) {
                let totalSize = response.headers.get("X-Total-Records");
                this.setState({
                    cardBatches: response.body,
                    totalSize: parseInt(totalSize, 10),
                    loading: false
                });
            } else {
                ToastHelper.error(response);
            }
        });
    }

    onItemClick(item) {
        this.props.history.push(this.baseUrl + "#" + VIEW_STATE_VIEW + "&id=" + item.id)
        this.setState({
            viewMode: VIEW_STATE_VIEW,
            batchId: item.id
        });
    }

    btnBackClick() {
        this.props.history.push(this.baseUrl)
        this.setState({
            viewMode: VIEW_STATE_SEARCH,
            batchId: 0
        });
    }

    handleSubmit() {
        this.tableRef.resetPage();
        this.loadData();
    }

    getHeader() {
        if (this.state.batchId === 0)
            return <Fragment>Card Batch</Fragment>
        else
            return <Fragment>
                <LinkComponent href="#" onClick={this.btnBackClick.bind(this)}><span className={"batchCardTableHeader"}>Card Batch</span></LinkComponent>
                {' / ' + this.state.batchId}
            </Fragment>
    }

    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Row className="justify-content-center">
            <Fragment>
                <Col md="10">
                    <Card className="p-2 cardBatchContainer">
                        <CardHeader>
                            {this.getHeader()}
                        </CardHeader>
                        <CardBody>
                            {this.state.viewMode === VIEW_STATE_SEARCH && this.renderBatchSearch()}
                            {this.state.viewMode === VIEW_STATE_VIEW && this.renderBatchView()}
                        </CardBody>
                    </Card>
                </Col>
            </Fragment>
        </Row>
    }

    renderBatchSearch() {
        return <Fragment>

            <CustomPaginatedDataTableComponent
                ref={ref => this.tableRef = ref}
                tableColumnConfig={CardBatch.getColumnConfig()}
                tableData={this.state.cardBatches}
                totalRecords={this.state.totalSize}
                onHeadersChange={this.loadData.bind(this)}
                onRowClick={(item) => this.onItemClick(item)}
                createSearchGroup={() => {
                    return <SearchInputGroup
                        ref={ref => this.searchRef = ref}
                        onSubmit={this.handleSubmit}
                        searchFields={[
                            {searchKey: "search", placeholder: "Search"}
                        ]}
                    />
                }}
            />
        </Fragment>
    }

    renderBatchView() {
        return <CardBatchView
            batchId={this.state.batchId}
            btnBackClick={this.btnBackClick.bind(this)}
        />
    }
}

export default withRouter(CardBatchSearch);
